import { DriveItem, ManufacturerItem } from "@/drive/interface";
import { FirmwareItem } from "@/firmware/interface";
import { FileItem } from "@/shared/FileItem";

export interface IFirmwareProvider {
  onDefaultDriveLoad?: () => Promise<DriveItem>
  onManufacturersLoad?: (connectionType: number, type: number) => Promise<ManufacturerItem[]>
  onDrivesLoad?: (connectionType: number, type: number, manufacturer: string) => Promise<DriveItem[]>
  onMqttDriveLoad?: (version: number, platform: number) => Promise<FileItem>
  onFirmwaresLoad?: (boxType: number) => Promise<FirmwareItem[]>
  onPlcDriveLoad?: (plcId: number) => Promise<DriveItem>
}

export interface IModuleConfig {
  language: string
  /** 后端接口地址 */
  exposedApiUrl?: string
  /** 固件及驱动配置 */
  firmware: {
    /** API请求地址 */
    url?: string
    /** 用于请求的secret */
    secret?: string
    /** Provider接口用于实现自定义接口请求 */
    provider?: IFirmwareProvider
  }
}

export let moduleConfig: IModuleConfig = {
  language: 'zh-CN',
  firmware: {
  }
};

export default (cfg: IModuleConfig) => {
  moduleConfig = cfg;
}
